import React from 'react'
import styled from 'styled-components';
import resume from '../img/resume.jpg';
import PrimaryButton from './PrimaryButton';

function ImageSection() {
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <img src={resume} alt=""/>
            </div>
            <div className="right-content">
               
                <div className="about-info">
                    <div className="info-title">
                        <p>Nama Lengkap</p>
                        <p>Umur</p>
                        <p>Kewarganegaraan </p>
                        <p>Bahasa </p>
                        <p>Tempat Tinggal</p>
                        <p>Role</p>
                    </div>
                    <div className="info">
                        <p>: Bagus Fatwan Alfiat</p>
                        <p>: 23</p>
                        <p>: Indonesia </p>
                        <p>: Indonesia (Native), English (Basic) </p>
                        <p>: Bogor, Pamijahan</p>
                        <p>: Fullstack Developer</p>
                    </div>
                </div>
                <PrimaryButton title={'Download Cv'} />
            </div>
        </ImageSectionStyled>
    )
}


const ImageSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .left-content{
        width: 100%;
        img{
            width: 95%;
            object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span{
                font-size: 2rem;
            }
        }
        .paragraph{
            padding: 1rem 0;
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
    }
`;
export default ImageSection;
